import { isEqual } from "lodash";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, { IMdaeDataGridProps } from "../../../common_components/common_widgets/data-grid";
import { TOGGLE_DENIAL_RESPONSE_POPUP } from "../../analyzer/denials-predictor/reducers/denials-predictor-reducer";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
} from "../../../common_components/common_widgets/popup";
import { checkListIsEqual } from "../../../common_components/mdae-framework";
export const toggleDenialPredictorResponseGridPopup = (
  dispatch,
  isVisible,
  lineSequenceNumber = 0
) => {
  dispatch({
    type: TOGGLE_DENIAL_RESPONSE_POPUP,
    data: {
      isDenialResponsePopupVisible: isVisible,
      lineSequenceNumber: lineSequenceNumber
    },
  });
}
const DenialPredictorResponseGridPopup = (props) => {
  const dispatch = useDispatch();
  const limitDisplaytext = (cellElement) => {
    var cellTooltip = cellElement.displayValue;
    var cellText = '';
    var stringlengthToShow = denialResponseClaimType?.toUpperCase() == "I" ? 90 : 110;
    if (cellElement.displayValue.length > stringlengthToShow) {
      cellText = cellElement.displayValue.substring(0, stringlengthToShow).concat("...");
      return <div title={cellTooltip}>{cellText}</div>
    }
    else {
      return <div>{cellElement.displayValue}</div>;
    }
  };
  const caseDetailsDenialResponseList = useSelector(
    (state: any) => state.denialsPredictorReducer.caseDetailsDenialResponseList,
    checkListIsEqual
  );

  const denialResponseClaimType = useSelector(
    (state: any) => state.denialsPredictorReducer.denialResponseClaimType,
    isEqual
  );
  const lineSequenceNumber = useSelector(
    (state: any) => state.denialsPredictorReducer.lineSequenceNumber,
    isEqual
  );
  const responseDataGridOptions = useMemo(() => {
    return getResponseDataGridOptions(
      caseDetailsDenialResponseList,
      limitDisplaytext,
      denialResponseClaimType
    );
  }, [caseDetailsDenialResponseList]);

  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleDenialPredictorResponseGridPopup(dispatch, false);
        }}
      >
        Denials Predictor Flags
      </MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width={1200}
        height={470}
        className="-warning-popup"
        mdaeTitleRender={getPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_DENIAL_RESPONSE_POPUP,
            reducerName: "denialsPredictorReducer",
            widgetOptionBindings: {
              visible: "isDenialResponsePopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div>
                  <MdaeDataGrid
                    {...responseDataGridOptions}
                    onCellPrepared={(e) => {
                      if (e.rowType === "data" && e.data.caseLineId == lineSequenceNumber) {
                        e.cellElement.className = e.cellElement.className = " denial-alert-row-style"
                      }
                    }}
                  ></MdaeDataGrid>
                </div>
              </MdaePopupContent>
            </div>
          )
        }}
        mdaeFooterRender={() => {

        }}
      >

      </MdaePopup>
    </div>

  )
};

const getResponseDataGridOptions = (
  responseTableDataSource,
  limitDisplaytext,
  denialResponseClaimType
) => {
  const responseDataGridOption: IMdaeDataGridProps = {
    id: "pnlResponseList",
    keyExpr: 'amsFacsResponseId',
    height: "350px",
    filterRow: {
      visible: true,
    },
    headerFilter: {
      visible: true,
    },
    wordWrapEnabled: true,
    dataSource: responseTableDataSource,
    allowColumnResizing: true,
    allowColumnReordering: true,
    hoverStateEnabled: true,
    showBorders: true,
    mdaeColumns: [
      {
        caption: "CPT/DRG",
        dataField: "cptDrg",
        width: 90,
      },
      {
        caption: "Revenue Code",
        dataField: "revenueCode",
        width: 90,
        visible: denialResponseClaimType?.toUpperCase() == "I"
      },
      {
        caption: "Rule Group",
        dataField: "ruleGroup",
        width: 190,
        cellRender: limitDisplaytext,
      },
      {
        caption: "Rule Detail",
        dataField: "ruleDetail",
        cellRender: limitDisplaytext,
      },
      {
        caption: "Explanation",
        dataField: "ruleExplanation",
        width: denialResponseClaimType?.toUpperCase() == "I" ? 205 : 245,
        cellRender: limitDisplaytext,
      },
      {
        caption: "Recommendation",
        dataField: "actionRecommendation",
        width: denialResponseClaimType?.toUpperCase() == "I" ? 205 : 245,
        cellRender: limitDisplaytext,
      },
      {
        caption: "Flagged $",
        dataField: "flaggedAmt",
        width: 130,
        format: {
          type: "currency",
          precision: 2,
        },
      }
    ],
  };
  return responseDataGridOption;
};

export default DenialPredictorResponseGridPopup;